module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"rate":"Rate","amount":"Amount"},"ru":{"rate":"Курс","amount":"Сумма"},"ua":{"rate":"Курс","amount":"Сума"}}')
  delete Component.options._Ctor
}
